import script from "./ATRp.vue?vue&type=script&lang=js"
export * from "./ATRp.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__